import { EditOutlined , QuestionCircleOutlined , DeleteOutlined } from "@ant-design/icons";
import { Space, Table, Drawer , Button, Popconfirm, message } from 'antd';
import React from 'react';
import { useState } from 'react';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import accountService from "../../../api/account.service";

import { ADD_MODE, DEFAULT_MASTER_DRAWER_WIDTH, EDIT_MODE, SUCCESS_STATUS } from '../../../utility/Constants';
import commonUtility from "../../../utility/Utils";
import CustomTableSearch from "../../common/CustomTableSearch";
import DrawableCloseIcon from "../../common/DrawableCloseIcon";
import AccountEntry from "./AccountEntry";


const AccountList = () => {
    const state = useSelector((state)=>state.account) 

    const showTotal = (total, range) => `${range[0]}-${range[1]} of ${total} items`;
    const [page, setPage] = React.useState(1);

    const [visible, setVisible] = useState(false);

    const [isSuccessRefreshList, setIsSuccessRefreshList] = useState(false);
    const [filteredSearchList, setFilteredSearchList] = useState([]);
    
    const [accountList, setAccountList] = useState([]);
    const [accountData, setAccountData] = useState({
        id: 0,
        account_name: '',
        opening_balance: 0,
        group_master_id: '',
        group_description:'',
        is_special: 'N',
        is_closingstk: 'N',
        mode: EDIT_MODE,

        hsn_code:'',
        gstin:'',
        state:'',
        address:'',
    });
  
    const showDrawer = (rowdata) => {
    
    //console.log('rowdata',rowdata);

    setAccountData({
        id: rowdata.id,
        account_name: rowdata.account_name,
        opening_balance: rowdata.opening_balance,
        group_master_id: rowdata.group_master_id,
        group_description: rowdata.group_description,
       
        is_special: rowdata.is_special,
        is_closingstk: rowdata.is_closingstk,

        hsn_code:rowdata.hsn_code,
        gstin:rowdata.gstin,
        state: commonUtility.sanitizeValue(rowdata.state_id),
        address:rowdata.address,

        mode: EDIT_MODE
    })
  
      setVisible(true);
  
    };
  
  
    const onClose = () => {
      setVisible(false);
    };
  

    const confirmDelete = (e) => {
     

      
      const data = { formdata: { account_id: e} };
      accountService.deleteAccount(data).then((res) => {

        setIsSuccessRefreshList(false)
        if(res.response_data.affectedRows) {
          setIsSuccessRefreshList(true)
          // message.success(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        else{
          //message.error(res.response_msg);
          commonUtility.openNotification("bottom", "Message", res.response_msg);
        }
        
      });


    


    };
    
    const cancel = (e) => {
      console.log("No clik",e);
      //message.error('Click on No');
    };
  
    
  
  
    const columns = [
      { 
        title: '#', 
        dataIndex: 'index', 
        render: (text, record, index) => (page - 1) * 10 + ++index ,
        width: '5%',
      },
      {
        title: 'Ledger',
        dataIndex: 'account_name',
        key: 'account_name',
        sorter: (a, b) => a.account_name.localeCompare(b.account_name),
        
      },
      // {
      //   title: 'Opening',
      //   dataIndex: 'opening_balance',
      //   key: 'opening_balance',
      // },
      {
        title: 'Group',
        dataIndex: 'group_description',
        key: 'group_description',
        sorter: (a, b) => a.group_description.localeCompare(b.group_description),
      },

      // {
      //   title: 'Special',
      //   dataIndex: 'is_special',
      //   key: 'is_special',
      // },
      // {
      //   title: 'Closing Stock',
      //   dataIndex: 'is_closingstk',
      //   key: 'is_closingstk',
      // },
     
      {
        title: 'Action',
        key: 'action',
        width:'10%',
        render: (selectedObj) => (
          
          <Space size="middle">
            <>
              <Popconfirm
                title="Data cann't be undone if deleted. Do you want to delete? "
                icon={
                  <QuestionCircleOutlined
                    style={{
                      color: 'red',
                    }}
                  />
                }
                onConfirm={()=>confirmDelete(selectedObj.id)}
                onCancel={cancel}
                okText="Yes"
                cancelText="No"
              >
                <Button htmlType="button" type="danger" size="small" shape="round" >Delete <DeleteOutlined /></Button>
              </Popconfirm>
            </>


            <Button htmlType="button" type="ghost" size="small" shape="round" onClick={()=> showDrawer(selectedObj)}>Edit <EditOutlined /></Button>
          </Space>
        ),
      },
    ];
  
  
    useEffect(() => {
      accountService.accountList().then((res) => {
        // console.log(res.data.response_data);
        setAccountList(res.data.response_data);
        setFilteredSearchList(res.data.response_data);
      });
    },[state.account,isSuccessRefreshList])



    const onSearch = (e) => {
     
      setFilteredSearchList([]);
      const string = e.target.value;
      const filtered_list = accountList.filter((data) => JSON.stringify(data).toLowerCase().indexOf(string.toLowerCase()) !== -1);
      setFilteredSearchList(filtered_list)
    }
  
    return (
      <>

      <CustomTableSearch onSearchTable={onSearch} />

        <Table columns={columns} rowKey='id' dataSource={filteredSearchList}
        pagination={{
          showTotal,
          onChange(current) {
            setPage(current);
          }
        }}
        />
  
        <Drawer
            title="Edit Ledger"
            width={DEFAULT_MASTER_DRAWER_WIDTH}
            onClose={onClose}
            visible={visible}
            bodyStyle={{
              paddingBottom: 80,
            }}
            destroyOnClose = {true}
            closeIcon = {<><DrawableCloseIcon /></>}
  
          >
            <AccountEntry data={accountData} onDrawerClose={onClose} />
          </Drawer>
  
      </>
    );
}

export default AccountList